<template >
  <v-dialog
    :value="value"
    @input="handleUpdate" 
    width="550"
    overlay-class="custom-dialog-overlay"
    content-class="custom-dialog-content"
    :z-index="9999"
    attach
  >
    <v-card class="index-page pa-6 pa-sm-10 d-flex flex-column justify-center">
      <v-row no-gutters justify="center" align="center">

        <v-col cols="12" class="text-center mb-4">
          <span class="text-title ">เพิ่มเครดิตสำเร็จ</span>
        </v-col>

        <v-col cols="12" class="d-flex justify-center mb-4">
          <v-img src="@/assets/success_package.png" max-height="260px" contain />
        </v-col>
        <v-col cols="12" class="text-center mb-6">
          <div class="text-subtitle">
            ระบบได้ทำการเพิ่มแพ็กเกจให้ท่านเรียบร้อยแล้ว <br />
            ท่านสามารถเริ่มค้นหา Talent ที่ใช่ได้ทันที
          </div>
        </v-col>

      <v-card-actions class="justify-center pt-2 pb-4" v-if="checktalentsearch === false">
        <v-btn
          color="default_button_primary"
          class="btn-submit px-4"
          dark
          @click="$emit('redirect')"
        >
          ไปที่ Talent Search
        </v-btn>
      </v-card-actions>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {



  name: "DialogClaimSuccess",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      checktalentsearch: false,
    }
  },
  computed: {
    surveyImage() {
      return process.env.VUE_APP_USE_THEME === "SPU_ADMIN"
        ? require("@/assets/survey 1_0_SPU.png")
        : require("@/assets/survey 1_0.png");
    },
  },
  mounted() {
    if (this.$route.path === '/talentsearch') {
      this.checktalentsearch = true;
      // console.log("ผู้ใช้กำลังอยู่ที่หน้าข้อเสนอพิเศษ");
    }
  },
  methods: {
    // ✅ เพิ่มฟังก์ชันนี้เพื่อดักจับการปิด Dialog
    handleUpdate(val) {
      // ส่งค่ากลับไปให้ v-model ทำงานตามปกติ
      this.$emit('input', val);

      // ถ้า val เป็น false (คือ Dialog กำลังปิด) และ อยู่หน้า talentsearch
      if (!val && this.checktalentsearch) {
        window.location.reload(); // สั่งรีเฟรชหน้าจอ
      }
    }
  }
};
</script>

<style scoped>
/* CSS เหมือนเดิม */
::v-deep .v-dialog {
  border-radius: 24px !important;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
}

.btn-submit {
  border-radius: 16px;
  background-color: var(--v-theme_primary) !important;
}

.btn-gradient-primary {
  background: linear-gradient(90deg, #1976d2 0%, #42a5f5 100%) !important;
  font-weight: 600;
  letter-spacing: 0.5px;
}
.index-page {
  border-radius: 18px !important;
  font-family: 'Noto Sans Thai' !important;
  min-height: 590px;
}
.text-title {
  color: #333333;
  font-size: 22px;
  line-height: 1.5;
  font-weight: 700;
}
</style>